(() => {
  const securityCodeInfoButton = '.show-security-code-info-js'
  const securityCodeExplanation = '.security_code_explanation'

  const init = () => {
    $(securityCodeExplanation).hide();
    $('body').on('click', securityCodeInfoButton, showSecurityCodeExplanation);
  }
  const showSecurityCodeExplanation = () => {
    $(securityCodeExplanation).fadeIn();
  }
  $(init);
})();


